<template>
    <div class="text-2xl font-light pb-1 border-b mt-5">
        <slot></slot>
    </div>
</template>
